import React from 'react';
import 'styles/universal/UniversalTypeFilter.css';

const UniversalTypeFilter = ({types, highlightedKeys, itemClicked}) => {
    return (
        <>
            {types.map(([key, label]) => (
                <div
                    key={key}
                    className={`filter-item ${highlightedKeys.includes(key) ? 'highlighted' : ''}`}
                    onClick={() => itemClicked(key)}
                >
                    {label}
                </div>
            ))}
        </>
    );
};

export default UniversalTypeFilter;
